export const env = {
  API_URL: API_URL,
  PUBLIC_AWS_REGION: PUBLIC_AWS_REGION,
  PUBLIC_AWS_PUBLIC_BUCKET: PUBLIC_AWS_PUBLIC_BUCKET
};